export default {"src":"/_next/static/media/star.f6f4975a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};